import { useFeatureIsOn } from '@growthbook/growthbook-react'
import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Row, Col, Tabs, notification, message, Alert } from 'antd'
import {
  PeriodNavigator,
  ProjectionUploadModal,
  SpreadsheetsModal,
  UploadDraggerScreen,
  CreateTransactionModal,
  TallyForm,
} from 'modules/core/components'
import configuration from '../../../configuration'
import { Evolution, UserActions } from './components'
import { SiderLayout } from 'modules/core/layouts'
import { CONCEPTS, PROJECTION, ROLES, TAB_KEYS } from 'modules/core/constants'
import {
  /*GA,*/ checkedUpload,
  generateMessageError,
  isUserAllowed,
  sendUserDataToGTM,
} from 'modules/core/utils'
import { connect } from 'react-redux'
import { useDefaultCurrency, usePagination } from 'modules/core/customHooks'
import { handleDeleteAll } from './utils'
import control from 'modules/control'
import moment from 'moment'
import planning from 'modules/planning'
import processes from 'modules/processes'
import _ from 'lodash'

import './ControlDetail.scss'
import login from 'modules/login'

const {
  CONTROL__REAL__SALES__ABM,
  CONTROL__REAL__EXPENSES__ABM,
  CONTROL__REAL__HUMAN_RESOURCES__ABM,
  CONTROL__REAL__COSTS__ABM,
  CONTROL__REAL__OTHER_5__ABM,
  CONTROL__REAL__OTHER_6__ABM,
  CONTROL__REAL__OTHER_7__ABM,
  CONTROL__REAL__OTHER_8__ABM,
} = ROLES

// NOTE: En los roles, los conceptos deberian ser resueltos mediante restricciones de dimensiones y no de operaciones
const CONTROL__REAL__CONCEPT = {
  [CONCEPTS.IDS.SALES_ID]: {
    ABM: CONTROL__REAL__SALES__ABM,
  },
  [CONCEPTS.IDS.EXPENSES_ID]: {
    ABM: CONTROL__REAL__EXPENSES__ABM,
  },
  [CONCEPTS.IDS.COSTS_ID]: {
    ABM: CONTROL__REAL__COSTS__ABM,
  },
  [CONCEPTS.IDS.HUMAN_RESOURCES_ID]: {
    ABM: CONTROL__REAL__HUMAN_RESOURCES__ABM,
  },
  [CONCEPTS.IDS.OTHER_5_ID]: {
    ABM: CONTROL__REAL__OTHER_5__ABM,
  },
  [CONCEPTS.IDS.OTHER_6_ID]: {
    ABM: CONTROL__REAL__OTHER_6__ABM,
  },
  [CONCEPTS.IDS.OTHER_7_ID]: {
    ABM: CONTROL__REAL__OTHER_7__ABM,
  },
  [CONCEPTS.IDS.OTHER_8_ID]: {
    ABM: CONTROL__REAL__OTHER_8__ABM,
  },
}

const ControlDetail = ({
  downloadControlTemplateXLS,
  uploadCotrolFileXLS,
  periodList,
  fetchDataTable,
  dataTable,
  fetchAllDimensions,
  massiveCreateTransaction,
  fetchDataTableAntv,
  dataTableAntv,
  deleteAllTransaction,
  fetchCurrencyList,
  currencyList,
  fetchProcessesList,
  fetchUnmappedValues,
  unmappedValues,
  uploadRealExcelFile,
  loggedUser,
  shareLayout,
}) => {
  const extraConcept = useFeatureIsOn('feature-extra-concept')
  const abUploadExcelFile = useFeatureIsOn('ab_upload_excel_file')
  const enableTallyForm = useFeatureIsOn('ab_tally_form')
  let { periodId, conceptName, conceptId, tableType, currency } = useParams()
  const [activeTab, setActiveTab] = useState(tableType || TAB_KEYS.TAB_KEY_EVOLUTION)
  const [isTableLoading, setIsTableLoading] = useState(false)
  const [showUploadModal, setShowUploadModal] = useState(false)
  const [showSpreadsheetsModal, setShowSpreadsheetsModal] = useState(false)
  const [tablePagination, setTablePagination] = usePagination()
  const [dataSelection, setDataSelection] = useState([])
  const [isDeletingAll, setIsDeletingAll] = useState(false)
  const [showDeleteAll, setShowDeleteAll] = useState(false)
  const [typeOfLoad, setTypeOfLoad] = useState(PROJECTION.TYPE_UPLOAD_OPTION_DEFAULT)
  const [showCreateModal, setShowCreateModal] = useState(false)
  const [showProgressBar, setShowProgressBar] = useState(false)
  const [currencyChange, setCurrencyChange] = useState(null)
  const [isDisable, setIsDisable] = useState(false)
  const [showTableqp, setShowTableqp] = useState(false)
  const [settings, setSettings] = useState({})

  const defaultCurrencyData = useDefaultCurrency()
  let history = useHistory()
  const { t } = useTranslation()

  const auxCurrencyId = currencyChange ? currencyChange : defaultCurrencyData?.id

  useEffect(() => {
    if ((currency && currencyChange) || (!currency && currencyChange)) {
      setCurrencyChange(auxCurrencyId)
    } else {
      setCurrencyChange(parseInt(currency))
    }
  }, [currency, auxCurrencyId, currencyChange])

  useEffect(() => {
    setIsTableLoading(true)
    setShowProgressBar(true)
    fetchDataTableAntv({
      concept_id: conceptId,
      period_id: periodId,
      ...(auxCurrencyId && { currency_id: auxCurrencyId }),
    })
      .then(() => {
        setIsTableLoading(false)
        setTimeout(() => {
          setShowProgressBar(false)
        }, 2000)
      })
      .catch(() => {
        setIsTableLoading(false)
        setShowProgressBar(false)
      })
  }, [fetchDataTableAntv, conceptId, periodId, auxCurrencyId])

  useEffect(() => {
    fetchAllDimensions()
  }, [fetchAllDimensions, periodId, conceptId])

  useEffect(() => {
    fetchCurrencyList()
  }, [fetchCurrencyList])

  useEffect(() => {
    fetchUnmappedValues()
  }, [fetchUnmappedValues])

  const verifyPermission = (conceptId) => {
    const permission = [
      CONCEPTS.IDS.SALES_ID.toString(),
      CONCEPTS.IDS.EXPENSES_ID.toString(),
      CONCEPTS.IDS.COSTS_ID.toString(),
      CONCEPTS.IDS.HUMAN_RESOURCES_ID.toString(),
      CONCEPTS.IDS.OTHER_5_ID.toString(),
      CONCEPTS.IDS.OTHER_6_ID.toString(),
      CONCEPTS.IDS.OTHER_7_ID.toString(),
      CONCEPTS.IDS.OTHER_8_ID.toString(),
    ]
    if (permission.includes(conceptId.toString())) {
      return isUserAllowed(CONTROL__REAL__CONCEPT[conceptId].ABM)
    } else if (extraConcept) {
      return true
    }

    return false
  }

  const dataPeriod = periodList.find((el) => el.id === parseInt(periodId))
  const canUserUpload = !isTableLoading && verifyPermission(conceptId)

  const renderHeader = () => (
    <PeriodNavigator
      items={[
        { name: t('LABEL_CONTROL'), url: `/seguimiento/${periodId}` },
        { name: conceptName || '' },
      ]}
    />
  )

  const onRefresh = () => {
    setIsTableLoading(true)
    setShowProgressBar(true)
    fetchDataTableAntv({
      concept_id: conceptId,
      period_id: periodId,
      ...(auxCurrencyId && { currency_id: auxCurrencyId }),
    }).then(() => {
      setIsTableLoading(false)
      setTimeout(() => {
        setShowProgressBar(false)
      }, 2000)
      message.success(t('UPDATE_INFORMATION_MESSAGE'), 8)
    })
  }

  const onHandleRedirect = () => {
    if (abUploadExcelFile) {
      return `/seguimiento/${periodId}/${conceptName}/workflow/${conceptId}?type=real&keyExecution=${periodId}-${conceptId}`
    }
    return '/procesosdecarga'
  }

  const onHandleActivity = () => {
    return `/seguimiento/${periodId}/${conceptName}/workflow/${conceptId}?type=real&keyExecution=${periodId}-${conceptId}`
  }

  const onSuccessUploadFile = (response) => {
    if (abUploadExcelFile) {
      onRefresh()
    } else {
      checkedUpload({
        fetchProcessesList,
        setIsDisable,
        dataProjection: {
          id: conceptId,
          module: 'real',
        },
        onRefetch: onRefresh,
      })
    }
    sendUserDataToGTM(loggedUser, 'Seguimiento', `Cargar reales`, `Carga`)
    notification.success({
      message: t('FEEDBACK_EVERYTHING_READY'),
      description: (
        <>
          <span>{t('FEEDBACK_UPLOAD_DATA_FILE_SUCCESS')}</span>
          <span
            onClick={() => history.push(onHandleRedirect())}
            style={{ color: '#0047ba', cursor: 'pointer' }}
          >
            {t('LABEL_PROCESS_UPLOAD')}
          </span>
        </>
      ),
      duration: 0,
    })
    // GA.event(GA.ACTIONS.FILE_UPLOAD_REAL);
    // onRefresh()
  }

  const onFailUploadFile = (error) => {
    notification.error({
      key: 'error_file',
      message: t('FEEDBACK_DEFAULT_ERROR'),
      description: generateMessageError(error),
      duration: 0,
    })
    // GA.event(GA.ACTIONS.FILE_UPLOAD_REAL_ERROR);
  }

  const renderEmptyScreen = () => (
    <UploadDraggerScreen
      disabled={!canUserUpload}
      description={t('CONTROL_EMPTY_SCREEN_DRAG_TITLE')}
      downloadTemplate={() =>
        downloadControlTemplateXLS(
          t('CONTOL_TEMPLATE_FILE_NAME', {
            name: conceptName,
            period: dataPeriod.name,
            date: moment().format('lll'),
          }),
          { concept_id: conceptId, period_id: periodId },
        )
      }
      uploadFile={(fileList) =>
        uploadCotrolFileXLS(fileList, {
          period_id: periodId,
          concept_id: conceptId,
          type_file: 'follow_up',
          type_of_load: PROJECTION.TYPE_UPLOAD_OPTION_DEFAULT,
        })
      }
      onSuccessUpload={onSuccessUploadFile}
      onFailUpload={onFailUploadFile}
    />
  )

  const handleClickTableType = (key) => {
    setActiveTab(key)
    setShowTableqp(false)
    const currency = currencyChange
      ? currencyList.data.find((el) => el.id === currencyChange).id
      : defaultCurrencyData.id
    window.history.replaceState(
      null,
      '',
      `/seguimiento/${periodId}/${conceptName}/${conceptId}/${currency}/${key}`,
    )
  }

  const renderControlTables = () => (
    <Tabs defaultActiveKey={activeTab} size="small" onChange={handleClickTableType}>
      <Tabs.TabPane tab={t('FIELD_EVOLUTION')} key={TAB_KEYS.TAB_KEY_EVOLUTION}>
        {activeTab === TAB_KEYS.TAB_KEY_EVOLUTION && (
          <Evolution
            dataSource={dataTableAntv}
            isTableLoading={isTableLoading || isDisable}
            onRefresh={onRefresh}
            conceptId={conceptId}
            conceptName={conceptName}
            dataPeriod={dataPeriod}
            periodId={periodId}
            num_pages={dataTable.num_pages}
            tablePagination={tablePagination}
            setTablePagination={setTablePagination}
            dataSelection={dataSelection}
            setDataSelection={setDataSelection}
            canUserUpload={canUserUpload}
            isProgressLoading={isTableLoading}
            showProgressBar={showProgressBar}
            currencyData={
              currencyChange
                ? currencyList.data.find((el) => el.id === currencyChange)
                : defaultCurrencyData
            }
            activeTab={activeTab}
            showTableqp={showTableqp}
            setShowTableqp={setShowTableqp}
            settings={settings}
            setSettings={setSettings}
          />
        )}
      </Tabs.TabPane>
    </Tabs>
  )

  const onClose = () => {
    setIsDeletingAll(false)
    setShowDeleteAll(false)
  }

  const handleClick = (val) => {
    setCurrencyChange(val)
    window.history.replaceState(
      null,
      '',
      `/seguimiento/${periodId}/${conceptName}/${conceptId}/${val}`,
    )
  }

  const handleOnClickCompartir = () => {
    const {
      aggregatorName,
      cols,
      columns,
      default_format,
      default_value,
      rendererName,
      vals,
      valueFilter,
      rows,
    } = settings

    const dataTable = {
      ...(!_.isEmpty(settings) && {
        aggregatorName,
        cols,
        columns,
        default_format,
        default_value,
        rendererName,
        vals,
        valueFilter,
        rows,
      }),
    }

    const urlObj = new URL(window.location.href)
    const pathAndQuery = urlObj.pathname + urlObj.search

    shareLayout('real', `${periodId}-${conceptId}`, {
      path: pathAndQuery,
      config: { ...dataTable },
    })
      .then((response) => {
        message.success(t('FEEDBACK_COPY_URL_SUCCESS'), 8)
        const newUrl = response.payload.data.url_hash
        // .replace(
        //   'https://stg.getplika.com/',
        //   'http://localhost:3000/',
        // )
        navigator.clipboard.writeText(newUrl)
      })
      .catch((error) => {
        notification.error({
          message: t('FEEDBACK_DEFAULT_ERROR'),
          description: generateMessageError(error),
          duration: 0,
        })
      })
  }

  const renderUserActions = () => (
    <UserActions
      onClickFile={() => setShowUploadModal(true)}
      onClickSpreadsheets={() => setShowSpreadsheetsModal(true)}
      onClickActivity={() =>
        history.push(
          `/seguimiento/${periodId}/${conceptName}/${conceptId}/${
            currencyChange
              ? currencyList.data.find((el) => el.id === currencyChange)?.id
              : defaultCurrencyData?.id
          }/evolution/actividad?type=real&module=realDetail`,
        )
      }
      disabled={
        !canUserUpload || isDisable
        //   moment(period.end_date).format('YYYY-MM-01') ===
        //     moment(approve_date).format('YYYY-MM-01') ||
      }
      onClickDelete={() => setShowDeleteAll(true)}
      visible={showDeleteAll}
      loading={isDeletingAll}
      onCancelPopConfirm={() => setShowDeleteAll(false)}
      onConfirmPopConfirm={() =>
        handleDeleteAll({
          setIsLoading: setIsDeletingAll,
          deleteAll: () => deleteAllTransaction(periodId, conceptId),
          onRefetch: () =>
            fetchDataTable({
              period_id: periodId,
              concept_id: conceptId,
              page: tablePagination.page,
            }),
          onClose,
          sendUserDataToGTM: () =>
            sendUserDataToGTM(loggedUser, 'Seguimiento', 'Eliminar todo reales', 'Eliminación'),
        })
      }
      hasCreate={true}
      onClickCreate={() => setShowCreateModal(true)}
      extraButtons={{
        module_name: 'seguimiento',
        submodule_name: conceptId,
      }}
      currencyOptions={currencyList.data}
      onChangeCurrency={(val) => handleClick(val)}
      defaultCurrency={currencyChange ? currencyChange : defaultCurrencyData?.id}
      onClickUpload={() => history.push(onHandleActivity())}
      onClickCompartir={() => handleOnClickCompartir()}
    />
  )

  const onChangeTypeOfLoad = (e) => {
    setTypeOfLoad(e.target.value)
  }

  const onHandleUpload = (handleUploadProps) => {
    const { fileList, typeOfLoad } = handleUploadProps
    if (abUploadExcelFile) {
      return uploadRealExcelFile(fileList, {
        concept: conceptId,
        period: periodId,
        date_format: 'yyyy-mm-dd',
        type_of_load: typeOfLoad,
        upload_from: 'manual_loading',
        type_of_file: 'REAL',
      })
    }

    return uploadCotrolFileXLS(fileList, {
      period_id: periodId,
      concept_id: conceptId,
      type_of_load: typeOfLoad,
    })
  }

  return (
    <SiderLayout className="control-detail-container">
      {renderHeader()}
      {!_.isEmpty(dataTableAntv) && (
        <>
          <Row gutter={[8, 24]}>
            {enableTallyForm && <TallyForm loggedUser={loggedUser} />}
            <Col span={24}>{renderUserActions()}</Col>
            {unmappedValues.total_unmapped > 0 && (
              <Col span={24}>
                <Alert
                  message={t('CONTROL_UNMAPPED_VALUES_ALERT_MESSAGE')}
                  description={
                    <>
                      <span>
                        {t('CONTROL_UNMAPPED_VALUES_ALERT_DESCRIPTION_1', {
                          count: unmappedValues.total_unmapped,
                        })}
                      </span>
                      <span
                        onClick={() => history.push('/configuracion/dimensiones')}
                        className="link-to-configuration"
                      >
                        {t('CONTROL_UNMAPPED_VALUES_ALERT_DESCRIPTION_2')}
                      </span>
                      <span>{t('CONTROL_UNMAPPED_VALUES_ALERT_DESCRIPTION_3')}</span>
                    </>
                  }
                  type="warning"
                  showIcon
                  closable
                />
              </Col>
            )}
            <Col span={24}>{renderControlTables()}</Col>
          </Row>
          <ProjectionUploadModal
            title={t('CONTROL_UPLOAD_MODAL_TITLE')}
            visible={showUploadModal}
            onCancel={() => setShowUploadModal(false)}
            uploadFile={(fileList, typeOfLoad) => onHandleUpload({ fileList, typeOfLoad })}
            onSuccessUpload={onSuccessUploadFile}
            onFailUpload={onFailUploadFile}
            downloadTemplateFile={() =>
              downloadControlTemplateXLS(
                t('CONTOL_TEMPLATE_FILE_NAME', {
                  name: conceptName,
                  period: dataPeriod.name,
                  date: moment().format('lll'),
                }),
                { concept_id: conceptId, period_id: periodId },
              )
            }
            enabledTypeOfLoad={true}
            extraInformativeCurrency={true}
            sendUserDataToGTM={() =>
              sendUserDataToGTM(loggedUser, 'Seguimiento', `Cargar de reales`, `Carga`)
            }
          />
          <SpreadsheetsModal
            visible={showSpreadsheetsModal}
            onCancel={() => {
              setShowSpreadsheetsModal(false)
              setTypeOfLoad(PROJECTION.TYPE_UPLOAD_OPTION_DEFAULT)
            }}
            dataSpreadsheets={{
              type_load: 'seguimiento',
              concept_id: conceptId,
              type_of_load: typeOfLoad,
              period_id: periodId,
            }}
            onRefetch={onRefresh}
            onChangeTypeOfLoad={onChangeTypeOfLoad}
            typeOfLoad={typeOfLoad}
            enabledTypeOfLoad={true}
            periodId={periodId}
            conceptId={conceptId}
            setIsDisable={setIsDisable}
            dataProjection={{
              id: conceptId,
              module: 'real',
            }}
            sendUserDataToGTM={() =>
              sendUserDataToGTM(loggedUser, 'Seguimiento', `Cargar por spreadsheet reales`, `Carga`)
            }
          />
          <CreateTransactionModal
            title={t('ACTION_CREATE_TRANSACTION')}
            dataPeriod={dataPeriod}
            visible={showCreateModal}
            onCancel={() => setShowCreateModal(false)}
            onRefetch={onRefresh}
            onCreateTransaction={(values) =>
              massiveCreateTransaction({
                ...values,
                period_id: periodId,
                concept_id: conceptId,
                type_sync_data: typeOfLoad,
              })
            }
            onChangeTypeOfLoad={onChangeTypeOfLoad}
            typeOfLoad={typeOfLoad}
          />
        </>
      )}
      {_.isEmpty(dataTableAntv) && !isTableLoading && renderEmptyScreen()}
    </SiderLayout>
  )
}

const mapStateToProps = (state) => ({
  periodList: planning.selectors.getPeriodList(state),
  dataTable: control.selectors.getDataTable(state),
  dataTableAntv: control.selectors.getDataTableAntv(state),
  currencyList: configuration.selectors.getCurrencyList(state),
  unmappedValues: configuration.selectors.getUnmappedValues(state),
  loggedUser: login.selectors.getWhoAmI(state),
})

const mapDispatchToProps = {
  downloadControlTemplateXLS: control.actions.downloadControlTemplateXLS,
  uploadCotrolFileXLS: control.actions.uploadCotrolFileXLS,
  fetchDataTable: control.actions.fetchDataTable,
  fetchAllDimensions: configuration.actions.fetchAllDimensions,
  massiveCreateTransaction: control.actions.massiveCreateTransaction,
  fetchDataTableAntv: control.actions.fetchDataTableAntv,
  deleteAllTransaction: control.actions.deleteTransactionFilterByControl,
  fetchCurrencyList: configuration.actions.fetchCurrencyList,
  fetchProcessesList: processes.actions.fetchProcessesList,
  fetchUnmappedValues: configuration.actions.fetchUnmappedValues,
  uploadRealExcelFile: control.actions.uploadRealExcelFile,
  shareLayout: control.actions.shareLayout,
}

export default connect(mapStateToProps, mapDispatchToProps)(ControlDetail)
